import { gql } from "@apollo/client";
import { ZipcodeMapGeofenceType } from "./getZipcodeGeofenceListing";

export const GET_ZIPCODE_GEOFENCE_PAGE_LISTING = gql`
    query GetZipcodeGeofencePageListing($filters: ZipcodeGeofenceFiltersTypeInput,
                                        $pageRequest: PageRequestTypeInput) {
        getZipcodeGeofencePageListing(filters: $filters, pageRequest: $pageRequest) {
            content {
                id
                zipcode
                geometryType
                boundary
                notes
                status
                approvalComments
                descriptionType
                descriptionOther
                creatorId
                creatorName
                auditorId
                auditorName
                geofenceName
                geofenceType
                deliveredTotal
                warehouseName
                hubName
                createdAt
                updatedAt
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface ZipcodeGeofenceFiltersType {
    warehouseId?: number;
    zipcode?: string;
    geofenceStatus?: string;
    geofenceName?: string;
    creatorId?: number;
    // 创建时间区间（epoch 秒，含端点）
    createdAtFrom?: number;
    createdAtTo?: number;
    hubId?: number;
}

export interface ZipcodeGeofencePageResponseType {
    content: ZipcodeMapGeofenceType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

export interface GetZipcodeGeofencePageListingResponse {
    getZipcodeGeofencePageListing: ZipcodeGeofencePageResponseType;
}
